import React from 'react'
import Header from '../Components/Header'
import Footer from "../Components/Footer";
import { Link } from 'react-router-dom';
const Documentation = () => {
  return (
    <div>

        <Header></Header>


<Footer></Footer>
    </div>
  )
}

export default Documentation